import React, { useContext } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { AccessContext } from '../../contexts/AccessProvider';

const NAV_ITEMS = [
  { key: 'home', label: 'Home', icon: 'bi-house', to: '/' },
  { key: 'asset', label: 'Asset View', icon: 'bi-list-ul', pathSuffix: '' },
  { key: 'rich', label: 'Rich View', icon: 'bi-pie-chart', pathSuffix: '/advanced' },
  { key: 'chat', label: 'AI Chat', icon: 'bi-robot', pathSuffix: '/chat' },
];

export default function AssetBottomNav() {
  const { access_key: accessKey } = useParams();
  const location = useLocation();
  const { assetMap } = useContext(AccessContext);
  const asset = accessKey ? assetMap[accessKey]?.data : null;

  if (!accessKey || !location.pathname.includes(`/assets/access_key/${accessKey}`)) {
    return null;
  }

  const base = `/assets/access_key/${accessKey}`;

  return (
    <div className="d-flex align-items-center justify-content-around flex-grow-1 px-1">
      {NAV_ITEMS.map((item) => {
        if (item.key === 'rich' && !asset?.has_iot_integration) return null;
        if (item.key === 'chat' && !asset?.ai_chat_available) return null;

        const to = item.to || `${base}${item.pathSuffix}`;
        const active =
          item.key === 'home'
            ? location.pathname === '/'
            : item.key === 'asset'
              ? location.pathname === base
              : location.pathname.startsWith(to);

        return (
          <Link
            key={item.key}
            to={to}
            className={`text-decoration-none text-center small px-1 ${active ? 'text-primary fw-semibold' : 'text-black'}`}
            style={{ minWidth: 64 }}
          >
            <i className={`bi ${item.icon} d-block fs-5`} />
            <span style={{ fontSize: '0.7rem' }}>{item.label}</span>
          </Link>
        );
      })}
    </div>
  );
}
